export var actionTypePrefix = '@@love';
export var reduxKey = '@@love';
export var defaultSliceState = {
    isLoading: false,
    loveScore: 0,
    loveCount: 0,
};
//# sourceMappingURL=constants.js.map